import { createFileRoute } from '@tanstack/react-router'
import ClassroomPage from '@/pages/ClassroomPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/records/classroom/$entityid')({
  component: ClassroomPage,
})